export var SESSION_STORE_KEY = '_dd_s';